// extracted by mini-css-extract-plugin
module.exports = {"icon-wrapper":"_9e1425b4d3--icon-wrapper--WigYv"};